import React from 'react';
import BreadcrumbStep from './BreadcrumbStep';

const Breadcrumbs = ({ steps }) => {
  return (
    <div className="breadcrumbs-container">
      <div className="breadcrumbs-frame">
        {steps.map((step, index) => (
          <BreadcrumbStep 
            key={index} 
            name={step.name} 
            link={step.link} 
            isActive={step.isActive} 
            index={index + 1} 
          />
        ))}
      </div>
    </div>
  );
};

export default Breadcrumbs;
